import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class CategoryblogService {
  constructor(private restService: RestService) {}

  all(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('categoryblog/all', val_params);
  }

  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('categoryblog/list', val_params);
  }

  get(val_id: number) {
    return this.restService.get('categoryblog/edit', val_id);
  }

  save(data: any) {
    return this.restService.save('categoryblog/save', data);
  }

  update(val_id: number, data: any) {
    return this.restService.update('categoryblog/update', val_id, data);
  }

  delete(val_id: number) {
    return this.restService.delete('categoryblog/delete', val_id);
  }
}
